import fetchServer from "../fetchServer";

export default async function updateTax(id,data,cancelToken) {
  let result = {
    return: 0,
    msg: "Something went wrong updating tax!",
  };

  let props = {}
  if(cancelToken)
    props.cancelToken = cancelToken

  await fetchServer({
    method: "PATCH",
    url: `/product/v1/tax/${id}`,
    data,
    ...props
  })
    .then((res) => {
      if (res) {
        if (res.status >= 200 && res?.status < 300) {
          result = { return: 1, msg: "Successfull", data: res.data.data || [] };
        }
        else if (res?.data?.error) {
          result["msg"] = res.data.error
        };
      }
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}
